import Header from "./Header";
import Footer from "./Footer";
import './PrivacyPolicy.css';
import TermsofUseH2Webp from '../img/TermsofUse-h2.webp';
import TermsofUseH2 from '../img/TermsofUse-h2.png';

export default function Rule3DModel() {
    return (
        <div id="top">
            <Header />
            <div className="PrivacyPolicy">
                <div className="PrivacyPolicy__h2 rule">
                    <picture>
                        <source type="image/webp" srcSet={TermsofUseH2Webp} />
                        <img src={TermsofUseH2} alt="Terms of Use - BŌSŌ TOKYO 3D artwork" />
                    </picture>
                </div>
                <h2>Terms of Use - BŌSŌ TOKYO 3D artwork</h2>
                <p>These Terms of Use (hereinafter referred to as "Terms and Conditions") apply to the distribution of BŌSŌ
                    TOKYO 3D artwork to all lawful owners of BŌSŌ TOKYO NFTs("NFTs"). All persons who own the NFT ("Owner")
                    shall be governed by these Terms and Conditions.</p>

                <h3>1. Conditions of Use</h3>
                <p>
                    a. Owner must be of legal age to form a binding agreement in the country, state or other jurisdiction in
                    which the owner resides.<br />
                    b. Owner must declare that he/she is a citizen or resident of the country or region where BŌSŌ TOKYO
                    provides its services.<br />
                    c. Owner must store the NFT at all times during the mint.<br />
                    d. Owner must agree to these Terms and Conditions.
                </p>

                <h3>2. NFTs Management</h3>
                <p>
                    The Owner is solely responsible for the security of the NFTs belonging to his/her wallet (including the
                    proper management and implementation of relevant security measures).
                </p>

                <h3>3. What-You-Get</h3>
                <p>
                    No ownership rights or intellectual property rights in the artwork associated with the NFTs are granted to
                    the Owners of the NFTs.<br />
                    However, in accordance with these Terms and Conditions, BŌSŌ TOKYO grants the Owner of the NFTs a license
                    (the "License") for unlimited commercial use of the BŌSŌ TOKYO 3D artwork (hereinafter referred to as
                    "3Dartworks").
                </p>

                <h3>4. License & Prohibitions</h3>
                <p>
                    For each NFT owned, a single License is granted to use the 3Dartworks of one character from the BŌSŌ TOKYO
                    collection. This License has no usage limits, and as long as the Owner continues to own the NFT, there shall
                    be no restriction on the revenue generated through the use of the 3Dartworks.<br />
                    However, the sale of 3Dartworks data and the distribution of dead copies of 3Dartworks are strictly
                    prohibited.<br />
                    Changing the color tone of the 3Dartworks to black-and-white is permitted.<br />
                    Modifications to the 3Dartworks are permitted only with respect to clothing, shoes, masks, weapons, and
                    tools worn or carried by the character.<br />
                    Modifications to the character's hair or body are strictly prohibited. For example, altering the character's
                    skin texture or replacing parts such as hands or feet is prohibited.<br />
                    Additionally, removing the helmet worn by the character is prohibited.
                </p>

                <h3>5. Non-commercial and personal use</h3>
                <p>
                    When the Owner uses the distributed 3Dartworks for non-commercial and personal purposes, modifications to
                    the 3Dartworks are permitted. Modifications to the character's body are also allowed in such cases.<br />
                    However, even in this case, the sale of 3Dartworks data and the distribution of dead copies of 3Dartworks
                    are strictly prohibited.
                </p>

                <h3>6. Transfer of NFT</h3>
                <p>
                    These Terms shall be automatically incorporated into any transfer agreement (verbal and writing) between the
                    current owner ("Seller") and the new Owner.<br />
                    The License for the artwork is transferred together with the NFTs and upon transfer, the Seller shall
                    immediately cease any use (commercial or non-commercial) of the 3Dartworks.<br />
                    The Owner also agrees that, if any third party from whom you have purchased the NFT fails to pay any fees
                    owed to BŌSŌ TOKYO in connection with the NFTs transfer, BŌSŌ TOKYO may refuse to provide the Owner access
                    until such fee payment has been settled.
                </p>

                <h3>7. Indemnity</h3>
                <p>
                    The Owner agrees to indemnify and hold BŌSŌ TOKYO and its affiliates harmless from any and all claims,
                    demands, liabilities, damages, fines, taxes, costs and expenses (including, without limitation, reasonable
                    legal fees and court costs) arising out of or in connection with (a) the breach of these "Terms and
                    Conditions" or (b) any claim from a third party who fails to meet the terms of this NFT due to the fact that
                    it was acquired from the original Owner.
                </p>

                <h3>8. Disclaimer of Warranties</h3>
                <p>
                    BŌSŌ TOKYO, its contractors, and their respective affiliates provide the NFTs and 3Dartworks "as is" to
                    "whomever" and explicitly disclaim any representations or warranties of any kind, expressed or implied,
                    including warranties of title, non-infringement, merchantability, fitness for a particular purpose, course
                    of performance, course of dealing, or any trade practices.
                </p>

                <h3>9. Indemnification of Damages</h3>
                <p>
                    In no event shall BŌSŌ TOKYO, its contractors or their respective affiliates be liable for indirect,
                    incidental, and consequential damages or any other non-direct damages or special, punitive or similar
                    damages of any kind.
                </p>

                <h3>10. limitation of liability</h3>
                <p>
                    The maximum aggregate liability of BŌSŌ TOKYO and its contractors and their respective affiliates for all
                    damages and causes of action, whether in contract, tort (including negligence) or otherwise, shall be USD
                    100.
                </p>

            </div>
            <Footer />
        </div>
    );
}